module.exports = __webpack_public_path__ + "static/media/iconStudentsActive.c471f1b9.svg";